import { apiFetch } from "#lib/api";
import { IFavoriteArtist } from "#entities/account";

export async function fetchFavoriteProfiles() {
  const path = `/account/favorites`;
  const params = new URLSearchParams([["type", "artist"]]);

  const data = await apiFetch<IFavoriteArtist[]>(
    path,
    { method: "GET" },
    params
  );

  return data;
}
